import commonApi, { AddressItem } from "@api/sharing/commonApi";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../rootReducer";

interface IState {
  addressItem: AddressItem | undefined;
}

const initialState: IState = {
  addressItem: undefined,
};

export const fetchCommonAddress = createAsyncThunk("common/fetchCommonAddress", async (code: string, thunkApi) => {
  try {
    const response = await commonApi.fetchCommonAddress(code);
    return response?.results?.[0];
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    resetCommonAddress: (state) => {
      state.addressItem = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCommonAddress.fulfilled, (state, action) => {
      state.addressItem = action.payload;
    });
  },
});

export default commonSlice.reducer;
export const { resetCommonAddress } = commonSlice.actions;
export const commonSliceState = (state: RootState) => state.commonSlice;
